import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { cdFetch } from "../api";
import { dummyDataForRebate, rebateTrackingFiltersData } from "../../utils/constants";

const getQueryParams = (
    email: string | null,
    commodity: string[] | null,
    district: string[] | null,
    vendor: string[] | null,
    category: string[] | null
) => {
    let qParams = "";

    if (vendor && vendor.length > 0) {
        qParams += `suppliers=${encodeURIComponent(JSON.stringify(vendor))}&`;
    }
    if (commodity && commodity.length > 0) {
        qParams += `commodity=${encodeURIComponent(JSON.stringify(commodity))}&`;
    }

    if (district && district.length > 0) {
        qParams += `district=${encodeURIComponent(JSON.stringify(district))}&`;
    }

    if (category && category.length > 0) {
        qParams += `category=${encodeURIComponent(JSON.stringify(category))}&`;
    }

    // if (email && email.length > 0) {
    //     qParams += `email=${encodeURIComponent(email)}&`;
    // }

    if (qParams.length > 0) {
        qParams = "?" + qParams.slice(0, -1);
    }

    return qParams;
};


export const useRebateTrackingFilters = (
    email: string | null,
    commodity: string[] | null,
    district: string[] | null,
    vendor: string[] | null,
    category: string[] | null,
) => {
    const { data, isLoading } = useQuery({
        queryKey: [
            queryKeys.businessCost,
            "filters",
            email,
            commodity,
            district,
            vendor,
            category
        ],
        queryFn: () => getFilters(email, commodity, district, vendor, category),
    });
    let fetchFilters: any = { ...data?.data?.data };

    return { fetchFilters, isLoading };
};

const getFilters = (
    email: string | null,
    commodity: string[] | null,
    district: string[] | null,
    vendor: string[] | null,
    category: string[] | null,
) => {
    const queryParams = getQueryParams(email, commodity, district, vendor, category);
    const res = cdFetch(`/getAllFiltersRebateTracking${queryParams}`);
    return res;
    // return Promise.resolve({
    //     data: {
    //         data: {
    //             data: rebateTrackingFiltersData,
    //         },
    //     },
    // });;;
};

export const useRebateTrackingDetails = (
    commodity: string[] | null,
    district: string[] | null,
    vendor: string[] | null,
    category: string[] | null,
) => {
    const { data, isLoading } = useQuery({
        queryKey: [queryKeys.rebateTrackingdetails, "rebate_tracking", vendor, commodity, district, category],
        queryFn: () => getRebateTrackingDetails(vendor, commodity, district, category),
        staleTime: 20000,
        enabled: true,
    });

    const rebateTrackingDetails =
        data?.data?.data;
    return {
        rebateTrackingDetails,
        rebateTrackingDetailsLoading: isLoading,
    };
};

const getRebateTrackingDetails = (
    vendor: string[] | null,
    commodity: string[] | null,
    district: string[] | null,
    category: string[] | null
) => {
    console.log("hit rebat")
    const queryParams = getQueryParams(
        null,
        (commodity = commodity),
        (district = district),
        (vendor = vendor),
        (category = category)

    );
    const res = cdFetch(`/getRebateTrackingData${queryParams}`);
    return res;
    // return Promise.resolve({
    //     data: {
    //         data: {
    //             data: dummyDataForRebate,
    //         },
    //     },
    // });;
};
